import { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AnimatedLoginPage from './components/auth/AnimatedLoginPage';
import AdminPanel from './components/admin/AdminPanel';
import Dashboard from './components/user/Dashboard';
import MobileGeoPage from './components/MobileGeoPage';
import MobileBlocker from './components/MobileBlocker';
import PrivateRoute from './components/auth/PrivateRoute';

const App: React.FC = () => {
  useEffect(() => {
    // Если домен не localhost и не совпадает с целевым, редирект
    // Это предотвращает доступ по IP (например, 192.168.0.54)
    if (window.location.hostname !== 'localhost' && !window.location.href.startsWith('https://tbl.zerdegroup.kz')) {
      window.location.replace(`https://tbl.zerdegroup.kz${window.location.pathname}${window.location.search}`);
    }
  }, []);

  return (
    <Router>
      <Routes>
        {/* Мобильная страница - БЕЗ блокировки */}
        <Route path="/mobile-geo" element={<MobileGeoPage />} />

        {/* Страница логина */}
        <Route path="/" element={<MobileBlocker><AnimatedLoginPage /></MobileBlocker>} />

        {/* Защищённые страницы */}
        <Route path="/admin" element={<MobileBlocker><PrivateRoute roleRequired={['admin', 'moder', 'view', 'guide', 'km', 'to', 'full-report']}><AdminPanel /></PrivateRoute></MobileBlocker>} />
        <Route path="/dashboard" element={<MobileBlocker><PrivateRoute roleRequired={['user', 'storage']}><Dashboard /></PrivateRoute></MobileBlocker>} />
      </Routes>
    </Router>
  );
};

export default App;